import React, { useEffect, useRef, useCallback } from "react";

const FBLogin = () => {
  const sdkReady = useRef(false);

  // Load FB SDK once
  useEffect(() => {

    console.log('VVprocess.env.GATSBY_FACEBOOK_APP_ID', process.env.GATSBY_FACEBOOK_APP_ID);
    console.log('VVprocess.env.GATSBY_API_BASE', process.env.GATSBY_API_BASE);

    if (document.getElementById("fb-sdk")) return;

    const s = document.createElement("script");
    s.id = "fb-sdk";
    s.async = true;
    s.defer = true;
    s.crossOrigin = "anonymous";
    s.src = "https://connect.facebook.net/en_US/sdk.js";

    // If Meta defines fbAsyncInit, it will call it automatically on load.
    (window).fbAsyncInit = () => {
      if (!window.FB) return;
      window.FB.init({
        appId: process.env.GATSBY_FACEBOOK_APP_ID, // <-- set in .env
        cookie: true,
        xfbml: false,
        version: "v23.0",
      });
      sdkReady.current = true;
    };

    s.onload = () => {
      // Safety: if fbAsyncInit didn’t run for some reason, init here.
      if (window.FB && !sdkReady.current) {
        window.FB.init({
          appId: process.env.GATSBY_FACEBOOK_APP_ID,
          cookie: true,
          xfbml: false,
          version: "v23.0",
        });
        sdkReady.current = true;
      }
    };

    document.body.appendChild(s);
  }, []);

  const handleLogin = useCallback(() => {
    if (!sdkReady.current || !window.FB) {
      alert("Facebook SDK not ready yet. Please try again in a moment.");
      return;
    }

    // VERY IMPORTANT: pass a normal function (not async) to FB.login
    window.FB.login(function (response) {
      if (!response || !response.authResponse) {
        alert("Facebook login cancelled/failed");
        return;
      }

      // Wrap async work so the FB SDK gets a normal function
      (async () => {
        try {
          const accessToken = response.authResponse.accessToken;
          const API_BASE = process.env.GATSBY_API_BASE; // <-- set in .env

          if (!API_BASE) {
            throw new Error("GATSBY_API_BASE is not set");
          }

          // NOTE: routes/api.php adds the /api prefix
          const res = await fetch(`${API_BASE}/auth/facebook/token`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ access_token: accessToken }),
          });

          if (!res.ok) {
            const text = await res.text();
            throw new Error(`API ${res.status}: ${text}`);
          }

          const data = await res.json();
          if (data?.token) {
            localStorage.setItem("authToken", data.token);
            window.location.href = "/candidate-profile-2";
          } else {
            alert("Login failed (no token returned).");
          }
        } catch (err) {
          console.error(err);
          alert("Login failed. Please try again.");
        }
      })();
    }, { scope: "email,public_profile" }); // add other scopes only if approved
  }, []);

  return (
    // <button
    //   onClick={handleLogin}
    //   className="font-size-4 font-weight-semibold position-relative text-white bg-marino h-px-48 flex-all-center w-100 px-6 rounded-5 mb-4"
    //   type="button"
    //   aria-label="Log in with Facebook"

    // >
    //   <i className="fab fa-facebook-square pos-xs-abs-cl font-size-7 ml-xs-4" />
    //   <span className="d-none d-xs-block">Log in with Facebook</span>
    // </button>
    <span className="text-center">
      FBLogin (In-Progress)
    </span>
  );
};

export default FBLogin;
